import { render, staticRenderFns } from "./PDFCierres.vue?vue&type=template&id=288ddca8&scoped=true&"
import script from "./PDFCierres.vue?vue&type=script&lang=js&"
export * from "./PDFCierres.vue?vue&type=script&lang=js&"
import style0 from "./PDFCierres.vue?vue&type=style&index=0&id=288ddca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ddca8",
  null
  
)

export default component.exports